import FieldModel from '../../models/FieldModel';
import {
  LIST_IDS,
  ON_CHANGE_FORM_FIELDS_ACTION,
  SET_COMMON_ACTION,
  SET_SIMPLE_NOTA_FISCAL_DEVEDOR_ACTION,
} from './NotaFiscalDevedor.constants';

function buildRequestFields() {
  return {
    periodoInicial: new FieldModel({
      name: 'periodoInicial',
      value: '',
    }),
    periodoFinal: new FieldModel({
      name: 'periodoFinal',
      value: '',
    }),
    valorInicial: new FieldModel({
      name: 'valorInicial',
      value: '0',
    }),
    valorFinal: new FieldModel({
      name: 'valorFinal',
      value: '9999999999.99',
    }),
    cpfCnpj: new FieldModel({
      name: 'cpfCnpj',
      value: '',
    }),
    numeroProcesso: new FieldModel({
      name: 'numeroProcesso',
      value: '',
    }),
    razaoSocial: new FieldModel({
      name: 'razaoSocial',
      value: '',
    }),
  };
}

function buildInitialStates() {
  return {
    formFields: buildRequestFields(),
    page: 0,
    rowsPerPage: 10,
    totalElements: 0,
    columnOrdenacao: { element: 'idProcesso', order: 'DESC' },
    arrowDirection: true,
    tableView: [],
    selectAll: false,
    listIds: {},
    atualizarListaIds: false,
    dadosResumo: [],
    idsProcessosExcluidos: [],
    common: {
      loadingPage: false,
    },
  };
}

function onChangeFormFieldsHandler(states, actions) {
  const { name, value } = actions;
  const model = states.formFields[name].getNewModel(value);

  return {
    ...states,
    formFields: {
      ...states.formFields,
      [name]: model,
    },
  };
}

function setSimpleNotasFiscaisDevedorHandler(states, actions) {
  const { name, value } = actions;
  return {
    ...states,
    [name]: value,
  };
}

function setSimpleValuesListIdsHandler(states, actions) {
  const { name, value } = actions;
  return {
    ...states,
    listIds: {
      ...states.listIds,
      [name]: value,
    },
  };
}

function setCommonHandler(states, actions) {
  const { name, value } = actions;
  return {
    ...states,
    common: {
      ...states.common,
      [name]: value,
    },
  };
}

export const onChangeFormFieldsAction = (name, value) => ({
  type: ON_CHANGE_FORM_FIELDS_ACTION,
  name,
  value,
});

export const setSimpleNotasFiscaisDevedorAction = (name, value) => ({
  type: SET_SIMPLE_NOTA_FISCAL_DEVEDOR_ACTION,
  name,
  value,
});

export const setSimpleValuesListIdsAction = (name, value) => ({
  type: LIST_IDS,
  name,
  value,
});

export const setCommonAction = (name, value) => ({
  type: SET_COMMON_ACTION,
  name,
  value,
});


export default (states = buildInitialStates(), actions) => {
  switch (actions.type) {
    case ON_CHANGE_FORM_FIELDS_ACTION:
      return onChangeFormFieldsHandler(states, actions);
    case SET_SIMPLE_NOTA_FISCAL_DEVEDOR_ACTION:
      return setSimpleNotasFiscaisDevedorHandler(states, actions);
    case LIST_IDS:
      return setSimpleValuesListIdsHandler(states, actions);
    case SET_COMMON_ACTION:
      return setCommonHandler(states, actions);
    default:
      return states;
  }
};
